import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";
import Image from "next/image";

function Shareworkspaces(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Shared Workspaces</HeaderH1>
      <Text>
        To share a workspace and collaborate with realtime updates, open the
        workspace modal. You can do this by either clicking the share button in the
        right-hand corner or the menu button in the workspace menu.
      </Text>
      <ImageBlock
        src={"/guide/share_button.png"}
        width={504}
        height={292}
        quality={100}
        alt={"Share button"}
        lessRounded={false}
      />
      <Text>
        In the modal, click the blue add button to invite other users to
        your workspace.
      </Text>
      <ImageBlock
        src={"/guide/shared_workspace_modal.png"}
        width={721}
        height={457}
        quality={100}
        alt={"Workspace modal"}
        lessRounded={true}
      />
      <Text>
        The invited user will see the invite in their workspace menu.
        Note: Only users on the Pro plan or Team plan can have multiple workspaces and use
        the shared workspace feature.
      </Text>
      <Text>
        Once they have accepted the invite, they will become collaborators in the
        workspace. This gives them access to all categories and
        groups, with reading and writing permissions. The workspace title and emoji can
        only be changed by the owner.
      </Text>
      <ImageBlock
        src={"/guide/roles_row.png"}
        width={504}
        height={292}
        quality={100}
        alt={"Roles in workspace"}
        lessRounded={false}
      />
      <Text>
        As users connect to the workspace, you will be able to see who has access
        and who was the last editor (this can also be seen for each note
        created).
      </Text>
      <NextButton
        cta={"Save tabs"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/save-tabs"}
      />
    </>
  );
}

Shareworkspaces.Layout = SideBar;

export default Shareworkspaces;
